// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
// ── Service inventory ────────────────────────────────────────────
export const PAYMENT_SERVICE_STATUSES = ['planned', 'live', 'suspended', 'retired'];
// ── eKYC evidence ────────────────────────────────────────────────
export const EKYC_OUTCOMES = ['passed', 'failed', 'inconclusive', 'abandoned'];
export const RETENTION_STATES = ['active', 'due', 'disposed', 'extended', 'conflicted'];
// ── Card and account evidence ────────────────────────────────────
export const CARD_EVIDENCE_STATUSES = ['current', 'superseded'];
// ── Customer due diligence cross-links ───────────────────────────
export const CDD_LINK_STATUSES = ['linked', 'unattributed', 'superseded'];
// ── Retention reconciliation ─────────────────────────────────────
export const RETENTION_RECONCILIATION_STATUSES = [
    'draft',
    'awaiting_second_approval',
    'complete',
    'superseded',
];
// ── Exceptions ───────────────────────────────────────────────────
export const PAYMENT_EXCEPTION_STATUSES = ['open', 'under_review', 'resolved', 'accepted'];
// ── Collections ──────────────────────────────────────────────────
export const PAYMENT_SERVICE_COLLECTION = 'grc_payment_services';
export const PAYMENT_LOG_MAPPING_COLLECTION = 'grc_payment_log_mappings';
export const EKYC_VERIFICATION_COLLECTION = 'grc_ekyc_verifications';
export const PAYMENT_DATA_SECURITY_COLLECTION = 'grc_payment_data_security_records';
export const AML_DILIGENCE_LINK_COLLECTION = 'grc_aml_diligence_links';
export const RETENTION_RECONCILIATION_COLLECTION = 'grc_retention_reconciliations';
export const PAYMENT_EXCEPTION_COLLECTION = 'grc_payment_evidence_exceptions';
//# sourceMappingURL=payments-evidence.js.map